<ng-container *appLoad="let trustId of trustId$">
  <app-audit-list
    [entityType]="entityType"
    [entityId]="trustId">
  </app-audit-list>
</ng-container> 